import Vue from 'vue'
import Unicon from 'vue-unicons'
import {
  uniFilm,
  uniMap,
  uniFileAlt,
  uniCheckSquare,
  uniGlobe,
  uniSignAlt,
  uniPhone,
  uniInfoCircle,
  uniPlus,
  uniMinus,
  uniArrowLeft,
  uniAngleLeft,
  uniAngleRight,
  uniTimes,
  uniTimesCircle,
  uniSort,
  uniAngleDown,
  uniAngleUp,
  uniPlay,
  uniSearch,
  uniSearchMinus,
  uniSearchPlus,
  uniUser,
  uniMars,
  uniVenus,
  uniBuilding,
  uniGrid,
  uniChart,
} from 'vue-unicons/src/icons'

Unicon.add([
  uniFilm,
  uniMap,
  uniFileAlt,
  uniCheckSquare,
  uniGlobe,
  uniSignAlt,
  uniPhone,
  uniInfoCircle,
  uniPlus,
  uniMinus,
  uniArrowLeft,
  uniAngleLeft,
  uniAngleRight,
  uniTimes,
  uniTimesCircle,
  uniSort,
  uniAngleDown,
  uniAngleUp,
  uniPlay,
  uniSearch,
  uniSearchMinus,
  uniSearchPlus,
  uniUser,
  uniMars,
  uniVenus,
  uniBuilding,
  uniGrid,
  uniChart,
])

Vue.use(Unicon)
